<template>
    <div class="form-group">
       <label>{{ lng.english_level}}</label>
        <select v-model="dataRequest.englishlevel"
              @change="send">
              <option v-for="item in getEngLevels"
                         :value="item.id" v-text="item.name"
                  ></option>
         </select>
    </div>


</template>

<script>
import {mapActions, mapGetters} from 'vuex';


export default {
   computed: {
        ...mapGetters([
           'lng',
           'langLevels',
           'selectedVT',
           'dataRequest'
           ]),
        getEngLevels(){
          let out = [];
          for(let key in this.langLevels) {
              let ob = {id: key, name: this.langLevels[key] }
              out.push(ob);
          }
          return out;
        }


   },
   methods: {
   ...mapActions([
      'prepareRequest',
       'sendRequest'
      ]),

      send() {
            this.prepareRequest({key: 'englishlevel', val: this.dataRequest.englishlevel});
            this.sendRequest();
      }

   }
}
</script>




// WEBPACK FOOTER //
// EnglishLevel.vue?95c68ae8